import React, { useState } from "react"
import { Link } from "react-router-dom"
import {
  Button,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  Row,
} from "reactstrap"
import footerLogo from "assets/images/footer-logo.svg"
import sent from "assets/images/sent-message.png"
import { post } from "api/axios"
import endpoints from "api/endpoints"
import captcha from "assets/images/captcha.png"
import { Bounce, toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

const Footer = () => {
  const [email, setEmail] = useState("")
  const footerItems = [
    {
      title: "Quick Links",
      items: [
        { title: "Home", path: "/" },
        { title: "About", path: "/about" },
        { title: "Video Vault", path: "/videovaults" },
        { title: "The Dockie Awards", path: "/thedockies" },
      ],
    },
    {
      title: "Policies",
      items: [
        { title: "Terms & Conditions", path: "/termcondition" },
        { title: "Privacy Policy", path: "/privacypolicy" },
      ],
    },
  ]

  const mailHandler = async () => {
    if (!email.trim()) {
      toast.error("Please enter an email address", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      })
      return
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      })
      return
    }

    try {
      const resp = await post(endpoints.mail, { email })

      if (resp.status === 201) {
        toast.success("You have successfully subscribed to the Newsletter", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        })
        setEmail("")
      } else {
        toast.error("You have already subscribed to the Newsletter", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        })
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again later.", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      })
    }
  }
  const navigate = useNavigate()

  const handleClick = () => {
    window.scrollTo(0, 0)
    navigate("/")
  }
  return (
    <footer className="black-bg-color footer mt-auto">
      <div className=" p-5">
        <div className="custom-row align-items-center justify-content-center  g-0 g-md-4 pt-3 py-md-4 px-lg-3">
          <div className="custom-col custom-col-12 custom-col-md-5">
            <div className="d-flex flex-column justify-content-center">
              <Link to="/" onClick={handleClick}>
                <img
                  src={footerLogo}
                  alt="footer-logo"
                  className="img-fluid ff-proxima"
                  height="80"
                  width="160"
                />
              </Link>
              <p className="secondary-white ff-proxima font-size-16 fw-normal m-0 text-uppercase pt-3">
                Dad Joke Headquarters
              </p>
            </div>
          </div>
          <div className="custom-col custom-col-12 custom-col-md-7">
            <div className="custom-row">
              {footerItems.map((el, index) => {
                return (
                  <div
                    className="custom-col custom-col-12 custom-col-md-3 ps-2"
                    key={index}
                  >
                    <h5 className="text-white text-uppercase pt-md-0 pt-2 ff-proxima font-size-18 fw-bolder">
                      {el.title}
                    </h5>
                    <ul className="nav flex-column pt-md-3 pb-md-0 pb-3 pt-0 ff-proxima fw-normal font-size-16">
                      {el.items.map((subEl, subIndex) => {
                        return (
                          <li
                            className="nav-item ff-proxima fw-normal font-size-16 py-1"
                            key={subIndex}
                          >
                            <Link
                              to={`${subEl.path}`}
                              className="secondary-white ff-proxima fw-normal font-size-16"
                              onClick={handleClick}
                            >
                              {subEl.title}
                            </Link>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                )
              })}
              <div
                xs="12"
                md="4"
                className="custom-col custom-col-12 custom-col-md-4 ps-0"
              >
                <h5 className="text-white text-uppercase fw-bolder ff-proxima font-size-18">
                  Mailing List
                </h5>
                <Form className="py-3">
                  <InputGroup
                    className="d-flex align-items-center bg-white ff-proxima border"
                    style={{
                      height: "56px",
                      borderRadius: "8px",
                      maxWidth: "342px",
                    }}
                  >
                    <Input
                      type="email"
                      className="form-control border-0 bg-transparent ff-proxima secondary-white"
                      placeholder="Email address"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                    />
                    <Button
                      color="link"
                      className="p-0"
                      onClick={e => {
                        mailHandler()
                      }}
                    >
                      <img src={sent} alt=".." className="me-2" />
                    </Button>
                  </InputGroup>
                </Form>
                <div className="d-flex gap-3 align-items-center ff-proxima fw-normal font-size-16 pt-1">
                  <img
                    src={captcha}
                    alt=""
                    height={"32px"}
                    width={"32px"}
                    className="ff-proxima fw-normal font-size-16"
                  />
                  <span className="secondary-white ff-proxima fw-normal font-size-16">
                    Captcha by Google
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="d-flex align-items-center justify-content-center py-2 landing-copyrights text-uppercase ff-proxima"
        style={{ backgroundColor: "#1E1E1E" }}
      >
        <span className="text-center text-white font-size-14 ff-proxima fw-normal">
          © {new Date()?.getFullYear()} Dock Tok, Inc. All Rights Reserved.
        </span>
      </div>
    </footer>
  )
}
export default Footer
